import {Settings} from 'react-slick';

const genericSettings: Settings = {
  speed: 1000,
  arrows: false,
  autoplaySpeed: 6000,
  initialSlide: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
};

export const featuredCarousel: Record<'desktop' | 'mobile', Settings> = {
  mobile: {
    ...genericSettings,
    infinite: true,
    centerMode: true,
    centerPadding: '24px',
  },
  desktop: {
    ...genericSettings,
    centerMode: false,
    centerPadding: '0px',
    swipe: false,
    swipeToSlide: false,
    infinite: false,
    initialSlide: 0,
  },
};
